import styled from 'styled-components';

export const TabDiv = styled.div`
    margin: 0px 0px 10px 0px;
    color: ${({ isActive, theme }) => (isActive ? theme.colors.primary300 : theme.colors.neutral900)};
    cursor: pointer;
    border-bottom: ${({ isActive, theme }) => (isActive ? `3px solid ${theme.colors.primary700}` : 'none')};

    &:hover {
        color:  ${({ isActive, theme }) => (isActive ? `${theme.colors.primary300} !important` : theme.neutral100)};
    }
`;

export const TabNameDiv = styled.div`
    display: inline-block;
    font-size: 15px;
    font-weight: 600;
    margin: 8px 10px;
    line-height: 32px;
`;
